"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SmbClient = void 0;
const GraphqlClient_1 = require("../graphql/GraphqlClient");
const commons_logs_1 = require("@deliverr/commons-logs");
const SMBBookingMutationResult_1 = require("./booking-upsert/SMBBookingMutationResult");
const SMB_GRAPHQL_URL = process.env.SMB_GRAPHQL_URL;
class SmbClient extends GraphqlClient_1.GraphqlClient {
    constructor(config = {
        baseURL: `${SMB_GRAPHQL_URL}`,
    }) {
        super(config);
        if (!SMB_GRAPHQL_URL) {
            commons_logs_1.log.warn("SMB_GRAPHQL_URL environment variable is not set");
        }
    }
    async commerceSearch(input, authToken) {
        const query = `query CommerceSearch($input: SmbCommerceSearchInput!) {
      commerceSearch(input: $input) {
        title
        labels
        transitTimes
        totalPrice
        mode
        calculatedEtaInDays
        incoterm
        baseOffering {
          offeringFid
          status
          configurationFid
          productFid
          productDistinctKey
          clientFid
          attributes {
            slug
            type
            valueTypeUrl
            value
          }
        }
        cmChargesForOfferings {
          offeringFid
          charges {
            slug
            expirationDate
            evaluatedSell {
              totalAmount
              currencyCode
              items {
                id
                amount
                currencyCode
                evaluateItemSlug
              }
            }
          }
        }
      }
    }`;
        commons_logs_1.log.info(input, "commerceSearch request input");
        return super
            .query(query, authToken, { input })
            .then((response) => {
            if (response.errors) {
                commons_logs_1.log.error(response.errors, "commerceSearch API request succeeded but returned error");
                return response;
            }
            commons_logs_1.log.info(response, "commerceSearch API request succeeded");
            return response;
        })
            .catch((error) => {
            commons_logs_1.log.error(error, "commerceSearch API request failed");
            throw error;
        });
    }
    async upsertBooking(shippingPlanId, bookingDetails, authToken) {
        const query = `
    mutation SmbUpsertBooking($shippingPlanId: String!, $bookingDetails: SmbUpsertBookingInput!)
    {
      smbUpsertBooking(shippingPlanId: $shippingPlanId, bookingDetails: $bookingDetails)
      {
        status,
        newSupplierCompanyCreated,
        newSupplierContactCreated,
        booking {
          id,
          shippingPlanId,
          flexId,
          draftClientOrder {
            fid,
            demandFacts{
              name,
              serviceModes,
              incoterm,
              involvedParties {
                shipperEntityFid,
                consigneeEntityFid,
                sellerEntityFid,
                buyerEntityFid
              },
              routes {
                originAddressFid,
                originPortFid,
                destinationAddressFid,
                destinationPortFid,
                viaPortFid
              },
              containerCounts {
                size,
                type,
                count
              },
              cargo {
                total {
                  weight
                  volume,
                  metricUnits,
                  slac
                },
                estimatedCommercialInvoiceValue,
                packageDetails {
                  weight,
                  volume,
                  count,
                  atomicCount,
                  metricUnits,
                  unitType,
                  subUnitType,
                  measurement {
                    length,
                    width,
                    height,
                    metricUnits
                  }
                },
                description {
                  marksAndNumbers,
                  products {
                    productDescription,
                    productDescriptionInLocalLanguage,
                    sixDigitHsCode
                  }
                }
              },
              compliance {
                declaredAsDangerous,
                dangerousGoodsState {
                  containsHazmat,
                  containsLithiumIonBattery,
                  containsNonLithiumIonBattery,
                  containsMagnets,
                  containsOtherDangerousGoods,
                  lithiumBatteriesPackingTypes
                },
                subjectToExportControl,
                exportControlCode
              },
              mainFreight {
                wantsFlexportFreight,
                serviceTier,
                freightType,
                carrierSpecs {
                  carrierFid,
                  contractNumber
                }
              },
              valueAddedService {
                wantsPickupService,
                wantsDeliveryService,
                wantsExportCustomsService,
                wantsImportCustomsService,
                wantsFlexportInsurance
              },
              userDefinedMetadata {
                label,
                values
              },
              shippingDates {
                estimatedCargoReadyDate,
                estimatedTargetDeliveryDate
              },
              freightInfo {
                countryOfOrigin,
                countryOfDestination,
                mblNumber,
                containerNumber,
                voyageNumber,
                vesselName
              },
              tradeService {
                customsServiceType,
                customsBond
              },
              contactInfo {
                shipperContactFid
              },
              note {
                specialInstructions
              },
              insurance {
                cargoValueCents,
                insurancePremiumCents
              },
              tracker {
                creationSource {
                  isFromSmbApp
                }
              }
            },
            offeringFids,
            createdByUserFid
          },
          clientOrder {
            fid,
            demandFacts{
              name,
              serviceModes,
              incoterm,
              involvedParties {
                shipperEntityFid,
                consigneeEntityFid,
                sellerEntityFid,
                buyerEntityFid
              },
              routes {
                originAddressFid,
                originPortFid,
                destinationAddressFid,
                destinationPortFid,
                viaPortFid
              },
              containerCounts {
                size,
                type,
                count
              },
              cargo {
                total {
                  weight
                  volume,
                  metricUnits,
                  slac
                },
                estimatedCommercialInvoiceValue,
                packageDetails {
                  weight,
                  volume,
                  count,
                  atomicCount,
                  metricUnits,
                  unitType,
                  subUnitType,
                  measurement {
                    length,
                    width,
                    height,
                    metricUnits
                  }
                },
                description {
                  marksAndNumbers,
                  products {
                    productDescription,
                    productDescriptionInLocalLanguage,
                    sixDigitHsCode
                  }
                }
              },
              compliance {
                declaredAsDangerous,
                dangerousGoodsState {
                  containsHazmat,
                  containsLithiumIonBattery,
                  containsNonLithiumIonBattery,
                  containsMagnets,
                  containsOtherDangerousGoods,
                  lithiumBatteriesPackingTypes
                },
                subjectToExportControl,
                exportControlCode
              },
              mainFreight {
                wantsFlexportFreight,
                serviceTier,
                freightType,
                carrierSpecs {
                  carrierFid,
                  contractNumber
                }
              },
              valueAddedService {
                wantsPickupService,
                wantsDeliveryService,
                wantsExportCustomsService,
                wantsImportCustomsService,
                wantsFlexportInsurance
              },
              userDefinedMetadata {
                label,
                values
              },
              shippingDates {
                estimatedCargoReadyDate,
                estimatedTargetDeliveryDate
              },
              freightInfo {
                countryOfOrigin,
                countryOfDestination,
                mblNumber,
                containerNumber,
                voyageNumber,
                vesselName
              },
              tradeService {
                customsServiceType,
                customsBond
              },
              contactInfo {
                shipperContactFid
              },
              note {
                specialInstructions
              },
              insurance {
                cargoValueCents,
                insurancePremiumCents
              },
              tracker {
                creationSource {
                  isFromSmbApp
                }
              }
            },
            offeringFids,
            createdByUserFid
          },
          type,
          offeringTitle,
          estimatedTimeOfArrival,
          flexibleDeliveryDate,
          originAddress {
            fid,
            streetAddress,
            streetAddress2,
            locality,
            administrativeArea,
            country,
            postalCode,
            hasLoadingDock,
            latitude,
            longitude
          },
          originPortGrouping {
            abbr,
            fid
          },
          destinationPortGrouping {
            abbr,
            fid
          },
          destinationAddress {
            fid,
            streetAddress,
            streetAddress2
            locality,
            administrativeArea,
            country,
            postalCode,
            hasLoadingDock,
            latitude,
            longitude
          },
          supplierContact {
            fid,
            name,
            email,
            phone
          },
          placedAt,
          shipmentTotal {
            pallets,
            boxes,
            units
          },
          supplier {
            companyFid,
            companyEntityFid,
            contactFid,
            companyName,
            contactName,
            contactPhone,
            contactEmail
          }
        },
        errorMessages
      }
    }
    `;
        commons_logs_1.log.info({ shippingPlanId, bookingDetails }, "upsertBooking request input");
        return super
            .query(query, authToken, { shippingPlanId, bookingDetails })
            .then((response) => {
            if (response.errors) {
                commons_logs_1.log.error(response.errors, "upsertBooking API request succeeded but returned error");
                return {
                    errors: response.errors,
                    data: response.data,
                };
            }
            else if (response.data.smbUpsertBooking.status !== SMBBookingMutationResult_1.SmbBookingMutationResultStatus.SUCCESS) {
                commons_logs_1.log.error(response, "upsertBooking API request succeeded but returned non-successful status");
                return {
                    errors: [
                        {
                            message: response.data.smbUpsertBooking.errorMessages,
                            status: response.data.smbUpsertBooking.status,
                        },
                    ],
                    data: response.data,
                };
            }
            commons_logs_1.log.info(response, "upsertBooking API request succeeded");
            return response;
        })
            .catch((error) => {
            commons_logs_1.log.error(error, "upsertBooking API request failed");
            throw error;
        });
    }
    async getSmbBooking(shippingPlanId, authToken) {
        const query = `
    query SmbBooking($shippingPlanId: String!) {
      smbBooking(shippingPlanId: $shippingPlanId) {
        id
        shippingPlanId
        flexId
        draftClientOrder {
          fid
          demandFacts {
            name
            serviceModes
            incoterm
            involvedParties {
              shipperEntityFid
              consigneeEntityFid
              sellerEntityFid
              buyerEntityFid
            }
            routes {
              originAddressFid
              originPortFid
              destinationAddressFid
              destinationPortFid
              viaPortFid
            }
            containerCounts {
              size
              type
              count
            }
            cargo {
              total {
                weight
                volume
                metricUnits
                slac
              }
              estimatedCommercialInvoiceValue
              packageDetails {
                weight
                volume
                count
                atomicCount
                metricUnits
                unitType
                subUnitType
                measurement {
                  length
                  width
                  height
                  metricUnits
                }
              }
              description {
                marksAndNumbers
                products {
                  productDescription
                  productDescriptionInLocalLanguage
                  sixDigitHsCode
                }
              }
            }
            compliance {
              declaredAsDangerous
              dangerousGoodsState {
                containsHazmat
                containsLithiumIonBattery
                containsNonLithiumIonBattery
                containsMagnets
                containsOtherDangerousGoods
                lithiumBatteriesPackingTypes
              }
              subjectToExportControl
              exportControlCode
            }
            mainFreight {
              wantsFlexportFreight
              serviceTier
              freightType
              carrierSpecs {
                carrierFid
                contractNumber
              }
            }
            valueAddedService {
              wantsPickupService
              wantsDeliveryService
              wantsExportCustomsService
              wantsImportCustomsService
              wantsFlexportInsurance
            }
            userDefinedMetadata {
              label
              values
            }
            shippingDates {
              estimatedCargoReadyDate
              estimatedTargetDeliveryDate
            }
            freightInfo {
              countryOfOrigin
              countryOfDestination
              mblNumber
              containerNumber
              voyageNumber
              vesselName
            }
            tradeService {
              customsServiceType
              customsBond
            }
            contactInfo {
              shipperContactFid
            }
            note {
              specialInstructions
            }
            insurance {
              cargoValueCents
              insurancePremiumCents
            }
            tracker {
              creationSource {
                isFromSmbApp
              }
            }
          }
          offeringFids
          createdByUserFid
        }
        clientOrder {
          fid
          demandFacts {
            name
            serviceModes
            incoterm
            involvedParties {
              shipperEntityFid
              consigneeEntityFid
              sellerEntityFid
              buyerEntityFid
            }
            routes {
              originAddressFid
              originPortFid
              destinationAddressFid
              destinationPortFid
              viaPortFid
            }
            containerCounts {
              size
              type
              count
            }
            cargo {
              total {
                weight
                volume
                metricUnits
                slac
              }
              estimatedCommercialInvoiceValue
              packageDetails {
                weight
                volume
                count
                atomicCount
                metricUnits
                unitType
                subUnitType
                measurement {
                  length
                  width
                  height
                  metricUnits
                }
              }
              description {
                marksAndNumbers
                products {
                  productDescription
                  productDescriptionInLocalLanguage
                  sixDigitHsCode
                }
              }
            }
            compliance {
              declaredAsDangerous
              dangerousGoodsState {
                containsHazmat
                containsLithiumIonBattery
                containsNonLithiumIonBattery
                containsMagnets
                containsOtherDangerousGoods
                lithiumBatteriesPackingTypes
              }
              subjectToExportControl
              exportControlCode
            }
            mainFreight {
              wantsFlexportFreight
              serviceTier
              freightType
              carrierSpecs {
                carrierFid
                contractNumber
              }
            }
            valueAddedService {
              wantsPickupService
              wantsDeliveryService
              wantsExportCustomsService
              wantsImportCustomsService
              wantsFlexportInsurance
            }
            userDefinedMetadata {
              label
              values
            }
            shippingDates {
              estimatedCargoReadyDate
              estimatedTargetDeliveryDate
            }
            freightInfo {
              countryOfOrigin
              countryOfDestination
              mblNumber
              containerNumber
              voyageNumber
              vesselName
            }
            tradeService {
              customsServiceType
              customsBond
            }
            contactInfo {
              shipperContactFid
            }
            note {
              specialInstructions
            }
            insurance {
              cargoValueCents
              insurancePremiumCents
            }
            tracker {
              creationSource {
                isFromSmbApp
              }
            }
          }
          offeringFids
          createdByUserFid
        }
        type
        offeringTitle
        estimatedTimeOfArrival
        flexibleDeliveryDate
        originAddress {
          fid
          streetAddress
          streetAddress2
          locality
          administrativeArea
          country
          postalCode
          hasLoadingDock
          latitude
          longitude
        }
        originPortGrouping {
          abbr
          fid
        }
        destinationPortGrouping {
          abbr
          fid
        }
        destinationAddress {
          fid
          streetAddress
          streetAddress2
          locality
          administrativeArea
          country
          postalCode
          hasLoadingDock
          latitude
          longitude
        }
        supplierContact {
          fid
          name
          email
          phone
        }
        supplier {
          companyFid
          companyEntityFid
          contactFid
          companyName
          contactName
          contactPhone
          contactEmail
        }
        placedAt
        shipmentTotal {
          pallets
          boxes
          units
        }
      }
    }
    `;
        commons_logs_1.log.info(shippingPlanId, "getting smb booking for shipping plan");
        return super
            .query(query, authToken, { shippingPlanId })
            .then((response) => {
            if (response.errors) {
                commons_logs_1.log.error(response.errors, "smbBooking API request succeeded but returned error");
                return response;
            }
            commons_logs_1.log.info(response, "smbBooking API request succeeded");
            return response;
        })
            .catch((error) => {
            commons_logs_1.log.error(error, "smbBooking API request failed");
            throw error;
        });
    }
}
exports.SmbClient = SmbClient;
//# sourceMappingURL=SmbClient.js.map